import React, { useState } from 'react';

export default function FillInPuzzle({ data, onSolved }) {
  const [guess, setGuess] = useState('');
  const [wrong, setWrong] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const normalized = guess.trim().toLowerCase();
    const isCorrect = data.acceptedAnswers.some(
      (a) => a.toLowerCase() === normalized
    );

    if (isCorrect) {
      onSolved();
    } else {
      setWrong(true);
      setTimeout(() => setWrong(false), 1200);
    }
  };

  return (
    <div className="puzzle-fillin">
      <p className="puzzle-prompt">{data.prompt}</p>
      <form onSubmit={handleSubmit} className="fillin-form">
        <input
          type="text"
          value={guess}
          onChange={(e) => setGuess(e.target.value)}
          placeholder="Type your answer..."
          className={`fillin-input ${wrong ? 'input-wrong' : ''}`}
          autoFocus
        />
        <button type="submit" className="puzzle-submit">Submit</button>
      </form>
      {wrong && <p className="puzzle-wrong">That's not it... try again! 💭</p>}
    </div>
  );
}
